import { t } from 'i18next';

import { IValidationWarningItem } from 'quotes/components/CustomerQuotePartList/QuotePartListTable/Actions/SubmitCustomerOrder/types';
import { AlternateOrderValidationWarning } from 'quotes/enums';

const getShortOrderWarningLabels = (): Partial<Record<string, string>> => ({
  [AlternateOrderValidationWarning.INACTIVE_BILL_TO_PROJECT_LINK]: t(
    'labelWarningInactiveBillToProjectLink'
  ),
  [AlternateOrderValidationWarning.INACTIVE_SHIP_TO_PROJECT_LINK]: t(
    'labelWarningInactiveShipToProjectLink'
  ),
  [AlternateOrderValidationWarning.MISSING_ISR_EMPLOYEE]: t('labelWarningMissingIsrEmployee'),
  [AlternateOrderValidationWarning.MISSING_OSR_EMPLOYEE]: t('labelWarningMissingOsrEmployee'),
});

// The tooltip renders "label: count", so a sentence's trailing period would collide with the colon.
export const getOrderWarningTooltipLabel = ({
  id,
  warning,
}: Pick<IValidationWarningItem, 'id' | 'warning'>): string =>
  getShortOrderWarningLabels()[id] ?? warning.replace(/\.\s*$/, '');
